import { apiClient } from "./ApiClient";

export const retrieveAllQuantitiesApi = () => apiClient.get(`/quantity-view/quantities`);
export const retrieveQuantityByItemIdApi = (itemId) => apiClient.get(`/quantity-view/quantity/item/${itemId}`);